<template>
  <div class="home-page">
    <div class="home-page-left">
      <div class="tools-options">
        <div
          class="tools-item"
          v-for="(item, index) in toolsData"
          :key="index"
          :style="{backgroundImage: 'url(' + item.imgSrc + ')'}"
          @click="selectTools(item)"
        >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

import species from '../assets/species.png'
import mnp from '../assets/mnp.png'
import parent_test from '../assets/parent_test.png'
import gvfinder from '../assets/gvfinder.png'
export default {
  name: "HomePage",
  data() {
    return {
      toolImg: [species, mnp, parent_test, gvfinder],
      toolsData: [
        {
          imgSrc: species,
          toolTitle: '种类鉴别',
          toolsValue: 'Species_identification'
        },{
          imgSrc: mnp,
          toolTitle: '品种鉴别',
          toolsValue: 'Variety_identification_by_MNP_markers'
        },{
          imgSrc: parent_test,
          toolTitle: '杂交菌株鉴别',
          toolsValue: 'Paternity_testing'
        },{
          imgSrc: gvfinder,
          toolTitle: '分子标记筛选',
          toolsValue: 'GVFinder'
        },
      ]
    }
  },
  methods: {
    selectTools(val) {
      // const routeData = this.$router.resolve({
      //   path: './ToolPage.vue',
      //   query: {
      //     toolData: val
      //   }
      // })
      // window.open(routeData.href, '_blank')
      this.$router.push({ 
        name: 'ToolPage',
        query: val
      })
      // this.$emit('selectTools', val)
    }
  }
}
</script>

<style scoped lang="scss">
.home-page {
  .home-page-left {
    padding: 0 20px 20px;
    height: calc(100vh - 174px);
    // overflow-y: auto;
    .home-page-introduce {
      font-size: 18px;
      padding: 20px;
      background: #eee;
      border-radius: 6px;
      .introduce-title {
        font-style: italic;
        font-size: 30px;
      }
    }
    .home-page-introduce:hover {
      box-shadow: 0 10px 20px 0 rgb(0 0 0 / 16%);
      transition: .3s;
    }
    .home-page-carousel {
      margin-top: 20px;
      .el-carousel__item img {
        width: 100%;
      }
    }
    .home-page-ribbon {
      margin-top: 20px;
      display: flex;
      .page-ribbon-item {
        width: 330px;
        border: 1px solid #cccccc;
        border-radius: 6px;
        padding: 20px;
        margin-right: 20px;
        text-align: center;
        cursor: pointer;
        .page-ribbon-img {
          height: 150px;
        }
        .page-ribbon-detail {
          margin-top: 20px;
          text-align: left;
          .page-ribbon-title {
            font-size: 30px;
            font-style: italic;
            margin-bottom: 10px;
          }
        }
      }
      .page-ribbon-item:hover {
        box-shadow: 0 10px 20px 0 rgb(0 0 0 / 16%);
        transition: .3s;
      }
    }
  }
  .tools-options {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tools-item {
      cursor: pointer;
      position: relative;
      // width: 242px;
      // height: 400px;
      width: 22%;
      height: inherit;
      background-repeat: no-repeat;
      // background-size: cover;
      background-size: contain;
      background-position: center center;
      .tools-title {
        color: #eee;
        font-size: 18px;
        font-weight: bold;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 5vh 3vh;
      }
    }
    .tools-item:hover {
      transform: scale(1.1);
      transition: .3s;
    }
  }
}
</style>
